import React, { ReactNode } from 'react';
import { motion } from 'framer-motion';

interface FloatingAnimationProps {
  children: ReactNode;
  duration?: number;
  delay?: number;
  distance?: number;
  scale?: number;
}

const FloatingAnimation: React.FC<FloatingAnimationProps> = ({
  children,
  duration = 3,
  delay = 0,
  distance = 15,
  scale = 1.02,
}) => {
  return (
    <motion.div
      initial={{ y: 0 }}
      animate={{ 
        y: [-distance/2, distance/2, -distance/2],
        scale: [1, scale, 1],
      }}
      transition={{
        duration: duration,
        delay: delay,
        repeat: Infinity,
        repeatType: "loop",
        ease: "easeInOut",
      }}
    >
      {children}
    </motion.div>
  );
};

export default FloatingAnimation; 